/** Prevent asynchronous reads from replacing a user-owned dirty form. */
export function createConfigDraftGuard() {
 let identity
 let dirty = false
 let snapshot
 return {
   edited() { dirty = true },
   saved() { dirty = false },
   get snapshot() { return snapshot },
   receive(key, value, sourceSnapshot) {
     if (identity !== key) { identity = key; dirty = false }
     const accepted = value != null && !dirty
     if (accepted) snapshot = sourceSnapshot
     return accepted
   },
 }
}
